
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 85.333 512 341.333"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#91DC5A","d":"M0 85.331h512v341.337H0z"}}),_c('path',{attrs:{"fill":"#FFF","d":"M0 85.331h512v341.337H0z"}}),_c('g',{attrs:{"fill":"#0052B4"}},[_c('path',{attrs:{"d":"M0 85.331h512v57.188H0zM0 369.48h512v57.177H0z"}})]),_c('path',{attrs:{"fill":"#D80027","d":"M0 165.215h512v181.582H0z"}}),_c('circle',{attrs:{"fill":"#FFF","cx":"190.33","cy":"255.994","r":"65.668"}}),_c('path',{attrs:{"fill":"#D80027","d":"M190.332 190.332l14.734 45.346h47.757l-38.65 28.028 14.849 45.481-38.69-28.16-38.631 28.107 14.79-45.428-38.616-28.028h47.722z"}})])
          )
        }
      }
    